import hotTopic from './hot-topics.vue'

export default hotTopic
